import axios from 'axios';

import * as actionTypes from './actionTypes';
import { baseEndpoint } from '../utility';


export const relationSet = (relationData) => {
    return (dispatch, getState) => {
        const state = getState();
        const authToken = state.auth.token;

        let url = baseEndpoint + 'relation/relation_manager/set_relations/';

        // load state information
        axios.post(url, relationData, {
            headers: {'Authorization': 'Token '+ authToken}
        })
            .then(function (response) {
                let data = response.data;
                dispatch(relationGetSucceeded(data));
            })
            .catch(function (error) {
                console.log(error);
            });
    }
};

export const relationGet = () => {
    return (dispatch, getState) => {
        const state = getState();
        const authToken = state.auth.token;

        let url = baseEndpoint + 'relation/relation_manager/load_relations/';

        // load state information
        axios.get(url, {
            headers: {'Authorization': 'Token '+ authToken}
        })
            .then(function (response) {
                let data = response.data;
                dispatch(relationGetSucceeded(data));
            })
            .catch(function (error) {
                console.log(error);
            });
    }
};

export const relationGetSucceeded = (data) =>{
    return {
        type: actionTypes.RELATION_GET,
        id: data.id,
        frequency: data.frequency,
        is_active: data.is_active,
        friends: data.friends,
        guests: data.guests,
        friend_count: data.friend_count,
        appointment_count: data.appointment_count
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/relation.js